import * as React from "react";
import clsx from "clsx";
import { Anchor } from "../typography/anchor/anchor.mjs";
import { Icon } from "../icon/icon/icon.mjs";
const BreadcrumbsItem = (props) => {
  const { label, current, ...rest } = props;
  return /* @__PURE__ */ React.createElement(
    "li",
    {
      className: clsx("breadcrumbs__item", {
        "is-current": current
      })
    },
    /* @__PURE__ */ React.createElement(
      Anchor,
      {
        isUnderlined: false,
        ...rest,
        className: "breadcrumbs__link",
        attributes: {
          "aria-current": current ? "page" : void 0
        }
      },
      label
    ),
    /* @__PURE__ */ React.createElement(Icon, { modifiers: "#arrow-right", className: "breadcrumbs__icon" })
  );
};
export {
  BreadcrumbsItem
};
